<template>
    <div>
        <div class="search flex">
            <span class="tit">药物管理</span>
            <div class="flex">
                <el-button @click="toEdit(null)" size="mini" class="addBtn">药物类别新增</el-button>
                <el-input
                        class="addART"
                        suffix-icon="el-icon-search" clearable
                        v-model="search"
                        size="mini"
                        placeholder="输入中文名搜索"/>
            </div>

        </div>
        <div class="instrument mt-5">
            <el-table
                    :data="categories.filter(data => !search || data.cnName.toLowerCase().includes(search.toLowerCase()))"
                    class="record-table"
                    :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                    height="calc(100vh - 250px)"
                    max-height="calc(100vh - 250px)" row-key="id">
                <el-table-column
                        prop="cnName"
                        label="中文名" align="center"
                        width="180" show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="enName"
                        label="英文名" align="center">
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0" style="color: orangered">封禁</span>
                        <span v-if="scope.row.status === 1" style="color: #56C147">正常</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备注" align="center">
                </el-table-column>
                <el-table-column
                        prop="sort"
                        label="排序" align="center">
                    <template slot="header">
                        <el-button @click="orderOk">排序</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status === 0" size="mini" type="text" class="btn"
                                   @click="changeStatus(scope.row)">启用
                        </el-button>
                        <el-button v-else size="mini" type="text" class="btn"
                                   @click="changeStatus(scope.row)">禁用
                        </el-button>
                        <el-button size="mini" type="text" class="btn" @click="toDelete(scope.row.id)">删除</el-button>
                        <el-button @click="toEdit(scope.row.id)" type="text" class="btn" size="mini" >编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>
    import commonjs from "../../../api/common";
    import Sortable from 'sortablejs';

    export default {
        name: "categoryList",
        data() {
            return {
                items: [],
                categories: [],//药物类别列表
                newCategories: [],//新的药物类别列表
                oldNum: 0,
                newNum: 0,
                search: '',
            }
        },
        mounted() {
            this.getData();
            this.rowDrop();
        },
        methods: {
          //获得数据
          getData() {
                let that = this;
                this.$ajax
                    .post(commonjs.api.drug.edit.category.list)
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.categories = res.data.list;
                            let data = [];
                            $(that.categories).each((index, obj) => {
                                if (obj.status === 0) {
                                    data.push({
                                        key: obj.sort,
                                        label: obj.cnName + "(已禁用)",
                                        id: obj.id,
                                    })
                                } else {
                                    data.push({
                                        key: obj.sort,
                                        label: obj.cnName,
                                        id: obj.id
                                    })
                                }
                            })
                            that.items = data;
                        }
                    })
            },
          //排序完成
          orderOk() {
                let that = this;
                // console.log(this.categories)
                $(this.categories).each((index, obj) => {
                    that.newCategories[index] = obj.id;
                });
                this.$ajax
                    .post(commonjs.api.drug.edit.category.order, this.newCategories)
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.$message({
                                message: '排序成功',
                                type: 'success'
                            })
                          that.getData();
                        } else {
                          that.$message.error(res.data.message);
                        }

                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败')
                })
            },
          //前往编辑
          toEdit(id) {
                if (id) {
                    this.$router.push({name: 'categoryEdit', query: {id: id}})
                } else {
                    this.$router.push({name: 'categoryEdit'})
                }
            },
          //删除
          toDelete(id) {
                let that = this;
                this.$confirm('如果只是想暂时下架药物类别,可禁用', '确认删除?', {
                    confirmButtonText: '删除',
                    cancelButtonText: '不删了',
                    type: 'warning'
                }).then(() => {
                    this.$ajax
                        .delete(commonjs.api.drug.edit.category.deleteCategory.replace("{categoryId}", id))
                        .then(function (res) {
                          if (res.data.status === 'success') {
                            that.$message.success('操作成功')
                            that.getData();
                          } else {
                            that.$message.error(res.data.message);
                          }
                        }).catch((err) => {
                      console.error(err);
                      that.$message.error('操作失败')
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
          //改变状态
          changeStatus(item) {
                let that = this;
                let msg;
                if (item.status === 0) {
                    msg = '启用'
                } else {
                    msg = '禁用'
                }
                this.$confirm('是否' + msg + '?', '确认信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$ajax
                        .post(commonjs.api.drug.edit.category.status.replace("{status}/{categoryId}", item.status + "/" + item.id))
                        .then(function (res) {
                          if (res.data.status === 'success') {
                            that.$message.success('操作成功')
                            item.status = (item.status+1)%2;
                          } else {
                            that.$message.error(res.data.message);
                          }
                        }).catch((err) => {
                      console.error(err);
                      that.$message.error('操作失败')
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
          //行拖拽
          rowDrop() {
                const tbody = document.querySelector('.el-table__body-wrapper tbody')
                const _this = this
                Sortable.create(tbody, {
                    onEnd({ newIndex, oldIndex }) {
                        const currRow = _this.categories.splice(oldIndex, 1)[0]
                        _this.categories.splice(newIndex, 0, currRow)
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../assets/css/medication.scss';
    @import '../../../assets/css/admin.scss';

    .tabs {
        margin-top: 20px;

        .instrument {
            margin-top: 0;
        }
    }
.addART{
    position: sticky;
}
    /*.ql-snow .ql-color-picker, .ql-snow .ql-picker.ql-header {
        line-height: 24px;
    }

    .flip-list-move {
        transition: transform 1s;
    }*/

    .items {
        width: 300px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border: 1px solid red;
    }
    .addART{margin-left: 20px}
</style>
